// @flow
import { makeStyles } from "@material-ui/styles";
export default makeStyles(() => ({
  tabs: {
    flex: 3, 
    display: "flex", 
    flexDirection: "column", 
    padding: 16, 
    overflowY: "hidden"
  }
}), { index: 1 })